var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardMobileNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11797_126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 4.28751C25 3.73751 24.55 3.28751 24 3.28751H1C0.45 3.28751 0 3.73751 0 4.28751V7.21251H25V4.28751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9.72501V20.725C0 21.275 0.45 21.725 1 21.725H24C24.55 21.725 25 21.275 25 20.725V9.72501H0ZM22.5 18.7125C22.5 18.9875 22.275 19.2125 22 19.2125H17.9875C17.7125 19.2125 17.4875 18.9875 17.4875 18.7125V15.9625C17.4875 15.6875 17.7125 15.4625 17.9875 15.4625H22C22.275 15.4625 22.5 15.6875 22.5 15.9625V18.7125Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11797_126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardMobileNav);
export default __webpack_public_path__ + "static/media/card_mobile_nav.ad69df1741b455b8e6a8d27c16b20afe.svg";
export { ForwardRef as ReactComponent };